import { useMutation } from '@tanstack/react-query';
import type { SwitchOrgRequest, SwitchOrgResponse } from './types';
import fetchData from '../fetcher';
import { useMyOgnizationStore } from '@/store';

const IAM_SWITCH_ORG_URL = '/iam/v4/auth/switch-org';

export const switchOrg = async ({ organization_id }: SwitchOrgRequest) => {
  const response = await fetchData<SwitchOrgResponse, SwitchOrgRequest>(IAM_SWITCH_ORG_URL, {
    method: 'POST',
    credentials: 'include',
    body: { organization_id },
  });
  const errorMessage = response.error_description || response.error || response.ErrorMessages?.[0];
  if (errorMessage) throw new Error(errorMessage);
  return response;
};

export const useSwitchOrg = () => {
  return useMutation({
    mutationFn: (data: SwitchOrgRequest) => switchOrg(data),
    onSuccess: (_data, variables) => {
      useMyOgnizationStore.getState().setCurrentOrganization(
        variables.organization_name
          ? { itemId: variables.organization_id, name: variables.organization_name }
          : variables.organization_id
      );
    },
  });
};
